export const getNextCurrentUserVoteState = (currentUserVoteState, subaction) => {
    if (subaction === currentUserVoteState.type) {
        return { type: 'INVALID' };
    }
    return { ...currentUserVoteState, pendingState: subaction };
};
export const getCurrentOwnerVote = (commentId, votes) => votes.find((vote) => vote.commentId === commentId);
const SCORE_ADJUST = { UPVOTE: 1, DOWNVOTE: -1, NEUTRAL: 0 };
const getScoreWithoutUserVote = (score, state) => {
    return score - SCORE_ADJUST[state];
};
export const getActualVotesScore = (state) => {
    return state.scoresWithoutUserVote + SCORE_ADJUST[state.currentUserVote.type];
};
export const getOptimisticVotesScore = (state) => {
    return (state.scoresWithoutUserVote +
        SCORE_ADJUST[state.currentUserVote.pendingState ?? state.currentUserVote.type]);
};
export const getVotesStateIN = (comment, votes) => {
    const currentUserVote = getCurrentOwnerVote(comment.commentId, votes) ?? { type: 'NEUTRAL' };
    return {
        currentUserVote,
        scoresWithoutUserVote: getScoreWithoutUserVote(comment.voteSummary.score ?? 0, currentUserVote.type),
    };
};
export const mergeVoteState = (prev, next) => {
    if (!prev.currentUserVote.pendingState) {
        // We only need to do merging if the state is in the middle of transition (like in signup on action flow)
        return next;
    }
    const nextCurrentUserVoteState = getNextCurrentUserVoteState(next.currentUserVote, prev.currentUserVote.pendingState);
    if (nextCurrentUserVoteState.type === 'INVALID') {
        // The previous action does not apply to refreshed state - for example user
        // trying to upvote, but ther already is an upvote
        return next;
    }
    // The pending action of previous state is applied to new state
    return {
        ...next,
        currentUserVote: nextCurrentUserVoteState,
    };
};
//# sourceMappingURL=comments-vote-utils.js.map